export const PADDING = 0;

export const HISTORY_LINE_HEIGHT = 76;

export const FULL_SIZE = 108 + HISTORY_LINE_HEIGHT;

export const LIMIT_HISTORY_ITEMS = Math.ceil(window.innerHeight / HISTORY_LINE_HEIGHT);
